import Vue from 'vue';

//element io
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import en from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(en);

Vue.use(ElementUI);